<template>
    <div :id="id"></div>
</template>

<script>
import wangEditor from 'wangeditor'
export default {
    name: "Editor",
    data(){
        return{
            editor: null,
            editorData: '',
            isInit:false,
            id:''
        }
    },
    model:{
        prop:'value',
        event:'change'
    },
    props:{
        value:String
    },
    created() {
        this.id = this.$utils.randomWords(8);
    },
    mounted() {
        this.createEditor();

        // let _a = '<p>修改建议追加（—）<span><o:p></o:p></span></p><p><![if><span>1.<span>&nbsp;&nbsp;</span></span><![endif]>在标讯发布详细内容的编辑器里添加一个附件上传的功能（<span>word或PDF）<o:p></o:p></span></p><p><![if><img src="file:////Users/zhanghebo/Library/Group%20Containers/UBF8T346G9.Office/TemporaryItems/msohtmlclip/clip_image001.png"/><![endif]><o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><b>下图为参考图<span><o:p></o:p></span></b></p><p><![if><img src="file:////Users/zhanghebo/Library/Group%20Containers/UBF8T346G9.Office/TemporaryItems/msohtmlclip/clip_image002.png"/><![endif]><o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><![if><span>2.<span>&nbsp;&nbsp;&nbsp;&nbsp;</span></span><![endif]>将“会员频道”与首页的企业logo在后台分开管理<o:p></o:p></p><p><![if><img src="file:////Users/zhanghebo/Library/Group%20Containers/UBF8T346G9.Office/TemporaryItems/msohtmlclip/clip_image003.png"/><![endif]><o:p></o:p></p><p>根据业务需求，首页企业logo的先后顺序在后台是可控的，所以分开管理会方便一些<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><![if><span>3.<span>&nbsp;&nbsp;&nbsp;&nbsp;</span></span><![endif]>在状态中添加一个只搜索VIP的选项<o:p></o:p></p><p><![if><img src="file:////Users/zhanghebo/Library/Group%20Containers/UBF8T346G9.Office/TemporaryItems/msohtmlclip/clip_image004.png"/><![endif]><o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><![if><span>4.<span>&nbsp;&nbsp;&nbsp;&nbsp;</span></span><![endif]>微信服务号的定时推送功能，推送时间为<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p>9：30，12：00，16：30<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><![if><img src="file:////Users/zhanghebo/Library/Group%20Containers/UBF8T346G9.Office/TemporaryItems/msohtmlclip/clip_image005.png"/><![endif]><o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><o:p>&nbsp;</o:p></p><p><o:p>&nbsp;</o:p></p><p><![if><span>5.<span>&nbsp;&nbsp;&nbsp;&nbsp;</span></span><![endif]>添加一条“发布时间“<o:p></o:p></p><p><![if><img src="file:////Users/zhanghebo/Library/Group%20Containers/UBF8T346G9.Office/TemporaryItems/msohtmlclip/clip_image006.png"/><![endif]><o:p></o:p></p>';
        //
        // let srcReg = /<img src=['"]([^'"]+)[^>]*\/>/g;
        //
        // let srcArr = _a.matchAll(srcReg)
        //
        // console.log(srcArr);
    },
    watch:{
        value(n,o){
            if(!this.isInit) {
                this.editor.txt.html(n);
                this.isInit = true;
            }
        }
    },
    methods:{
        createEditor(){
            let _this = this;
            const editor = new wangEditor('#'+this.id);
            // 配置 onchange 回调函数，将数据同步到 vue 中
            editor.config.onchange = (newHtml) => {
                this.editorData = newHtml;
                this.$emit('change',newHtml)
            }
            editor.config.uploadImgServer = this.$config.uploadUrl;
            editor.config.uploadFileName = 'file'
            editor.config.zIndex = 1;
            editor.config.height = 200
            editor.config.uploadImgHeaders = {
                Authorization : this.$user.getToken()
            }
            editor.config.uploadImgParams = {
                key: 'article',
            }
            editor.config.uploadImgHooks = {
                customInsert: function(insertImgFn, result) {
                    console.log(result);
                    if(result.code === 0) {
                        // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
                        insertImgFn(result.result.url.indexOf('http') >= 0 ? result.result.url : _this.$config.assetsUrl + result.result.url);
                    }else{
                        _this.$message.error({message: result.msg, duration: 2000});
                    }
                }
            }

            editor.config.colors = [
                '#000000',
                '#595757',
                '#999999',
                '#aaaaaa',
                '#cccccc',
                '#eeeeee',
                '#ffffff',
                '#ff0000',
                '#ff5900',
                '#ffd500',
                '#8bff8b',
                '#00ff00',
                '#008b00',
                '#14489d',
                '#0000ff'
            ]

            // editor.config.pasteTextHandle = function (pasteStr) {
            //     console.log(pasteStr);
            //
            //     // let imgReg = /<img.*?(?:>|\/>)/gi;
            //     // let imgReg = /<img [^>]*src=['"]([^'"]+)[^>]*>/gi;
            //     // 匹配src属性
            //     // let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/gi;
            //
            //     // let srcReg = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;
            //
            //     // let srcArr = pasteStr.match(srcReg)
            //     // let imgArr = pasteStr.match(imgReg)
            //
            //     // console.log(srcArr);
            //     // console.log(imgArr);
            //
            //     // 对粘贴的文本进行处理，然后返回处理后的结果
            //     return pasteStr;
            // }

            // 创建编辑器
            editor.create()

            // console.log(this.value);

            editor.txt.html(this.value);

            this.editor = editor
        },
    }
}
</script>
